



































import { defineComponent, PropType } from '@vue/composition-api';

import authMixin from '@/mixins/auth';
import { IBankPaymentInstructionPropertyData } from '@/models';

export default defineComponent({
  name: 'PaymentInstructionPropertyListItem',
  mixins: [authMixin],
  props: {
    paymentInstructionProperty: {
      type: Object as PropType<IBankPaymentInstructionPropertyData>,
      required: true
    }
  }
});
